import React, { useRef, useState } from "react"
import { useClickOutside } from "../../hooks"
import { CURRENCIES } from "../../../../../variables/common"
import { ChevronDown } from "lucide-react"
import { cn } from "../../../../../lib"
import { motion, AnimatePresence } from "framer-motion"
import { useDispatch, useSelector } from "react-redux"
import {
  selectAviaSearchCurrency,
  setAviaSearchParams,
} from "../../../../../app/reducers/book/aviaSearchSlice"

const CurrencySelector = ({ handleSearch }) => {
  const dispatch = useDispatch()
  const currency = useSelector(selectAviaSearchCurrency)
  const selected = CURRENCIES.find((item) => item.code === currency)

  const [isOpen, setIsOpen] = useState(false)

  // refs
  const dropdownRef = useRef(null)

  // cus hooks
  useClickOutside(dropdownRef, () => setIsOpen(false))

  //
  const onChange = async (code) => {
    try {
      if (code !== selected.code) {
        await handleSearch({ newCurrency: code })
      }
      dispatch(setAviaSearchParams({ key: "currency", value: code }))
      setIsOpen(false)
    } catch (error) {}
  }

  return (
    <div className="flex items-center justify-center absolute right-0 -bottom-9">
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={cn(
            "flex justify-between gap-2 px-1.5 py-1.5 text-second-success bg-white font-medium rounded-sm shadow-md transition-colors duration-200 cursor-pointer text-xs border-1 w-[67px]"
          )}
        >
          <span>{selected.symbol}</span>
          <span>{selected.code}</span>
          <ChevronDown
            className={`w-4 h-4 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
          />
        </button>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, y: -6, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -6, scale: 0.98 }}
              transition={{ duration: 0.18, ease: "easeOut" }}
              className="absolute top-full mt-2 w-full bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 z-50 flex items-center justify-center"
            >
              <div>
                {CURRENCIES.map((currency) => {
                  const isActive = selected.code === currency.code
                  return (
                    <button
                      key={currency.code}
                      onClick={() => onChange(currency.code)}
                      className={`w-full flex items-center gap-2 px-4 py-2.5 text-left transition-colors duration-150 text-xs cursor-pointer ${
                        isActive ? "text-second-success" : "text-text-main hover:bg-gray-50"
                      }`}
                    >
                      <span>{currency.symbol}</span>
                      <span className="font-medium">{currency.code}</span>
                    </button>
                  )
                })}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}

export default CurrencySelector
